import { Component, OnInit, NgZone, ViewEncapsulation } from '@angular/core';
import { FileService } from "../../services/file.service";
import { ActivatedRoute } from "@angular/router";
import 'rxjs/add/operator/switchMap';
import { Observable } from "rxjs/Observable";
import { MarkdownService } from 'angular2-markdown';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ViewComponent implements OnInit {

  constructor(
    private _fileService: FileService,
    private _route: ActivatedRoute,
    private zone: NgZone,
    private _markdown: MarkdownService) { }

  // mdurl : string = "https://gist.githubusercontent.com/jxson/1784669/raw/de4e1b30f4d08cb759dac19619d3d5ba1f35bc96/README.md";
  mdurl: string;
  file: string;

  ngOnInit() {
    this._route.paramMap.switchMap(p => {
      this.file = p.get('file');
      return this._fileService.getUrl(this.file);
    }).subscribe(p => {
      this.mdurl = p + '&f.md';
    });
    this._markdown.renderer.link = (href: string, title: string, text: string) => {
      return `<a href='${href}' onclick="
      try {
        const element = document.querySelector('${href}');
        if (element) { element.scrollIntoView(element); }
      } catch(e){}
      return false;
      ">${text}</a>`;
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/components/view/view.component.ts